import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { XTodoButton } from '@adornis/todo/client/x-todo-button.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { ChancenPermission } from '@chancenwerk/shared/permissions.js';
import type { ChancenwerkUser } from '@chancenwerk/shared/master-data-management/users/entities/ChancenwerkUser.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

/**
 * @customElement cr-todo-button
 */
@customElement('cr-todo-button')
export class ChromiumTodoButton extends XTodoButton {
  // @ts-expect-error TODO typing is wrong fram base
  @state() private override readonly _currentUser = new RXController(this, currentUser<ChancenwerkUser>());

  override render() {
    if (this._currentUser.value?.hasPermission(ChancenPermission.global.READ_TODOS)) {
      return super.render();
    }
    return html``;
  }
}
